// Onglet TUF — raccourcis + inventaire du portable nomade ASUS TUF F16 (node Tailscale kermhit).
// Tailnet-only : nécessite Tailscale actif sur l'appareil. Les tuiles ouvrent l'outil dans un nouvel onglet.

const HOST = "kermhit.tail3ea350.ts.net"

type Tool = { name: string; icon: string; desc: string; url: string; tag: string; accent: string }

const TOOLS: Tool[] = [
  { name: "Kirajean (TUF)", icon: "🤖", desc: "Chat IA — choisis le modèle : en ligne (Ollama Cloud) ou local sur la carte du TUF", url: `http://${HOST}:8091`, tag: "IA", accent: "#ec4899" },
  { name: "Fichiers (PC entier)", icon: "📂", desc: "Explorateur : C: + Disque-D, échange (Echange) — marche quand la session Windows est ouverte", url: `http://${HOST}:8085`, tag: "Fichiers", accent: "#eab308" },
  { name: "MeshCentral (parc)", icon: "🌐", desc: "Prendre la main à distance : écran, terminal, fichiers, éteindre/redémarrer (appareil TUF)", url: "https://srv836585.tail3ea350.ts.net:4430", tag: "Parc", accent: "#0891b2" },
  { name: "Moniteur cartes (parc)", icon: "📊", desc: "Température / charge des cartes de tout le parc (servi par MEGAPORT)", url: "http://kermhitaa.tail3ea350.ts.net:8086", tag: "Parc", accent: "#a855f7" },
]

const APPS: [string, string][] = [
  ["IA", "Kirajean (AJEAN 0.15.2, port 8091) · LM Studio 0.4.24 · llama.cpp b11200 (nœud inférence unifiée, RPC 50052, CUDA)"],
  ["Modèles IA locaux (RTX 4060 8 Go)", "Qwen2.5 7B Instruct Q4_K_M (4,4 Go) · Gemma 4 E4B Q4_K_M (5 Go, dossier LM Studio) — en ligne : Ollama Cloud deepseek-v4-flash, qwen3.5 397b"],
  ["Image (1 outil à la fois, 8 Go)", "Forge (Flux) · ComfyUI (Flux Schnell) · Fooocus (SDXL) · RuinedFooocus (en attente) — dossiers C:\\"],
  ["NVIDIA", "Pilote 616.92 · CUDA Toolkit 13.4 · NVIDIA App · Nsight"],
  ["Accès / réseau", "RustDesk 1.4.9 (ID 24118005) · MeshCentral · SSH · Tailscale 1.102 (node « kermhit »)"],
  ["Dev", "Git · Node.js 24 · Go 1.27 · CMake · ninja · Visual Studio Build Tools 2022 · Claude Code"],
  ["Bureautique / médias", "Microsoft 365 · OneNote · Chrome · Edge · Comet · Filmora 13 · VLC · Rufus"],
  ["Sécurité", "Defender actif (McAfee désinstallé 28/09) · ⚠️ WebAdvisor McAfee encore présent"],
]

export default function PcTufPage() {
  return (
    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "#111827" }}>
    <div style={{ padding: "24px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginBottom: "8px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", color: "#e6edf3" }}>🎒 TUF — portable nomade (kermhit)</h1>
        <p style={{ color: "#8b949e", fontSize: "13px", marginTop: "6px" }}>
          Le <b>portable nomade principal</b> (ASUS TUF F16) + 2ᵉ IA de secours. Tailnet-only : <b>Tailscale doit être actif</b> sur ton appareil.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "16px", marginTop: "20px" }}>
        {TOOLS.map((t) => (
          <a key={t.name} href={t.url} target="_blank" rel="noreferrer"
            style={{ display: "block", padding: "18px", borderRadius: "14px", background: "#161b22", border: "1px solid #30363d", textDecoration: "none", color: "#e6edf3", transition: "all .15s" }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = t.accent; e.currentTarget.style.transform = "translateY(-2px)" }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#30363d"; e.currentTarget.style.transform = "translateY(0)" }}
          >
            <div style={{ fontSize: "30px" }}>{t.icon}</div>
            <div style={{ fontWeight: 600, fontSize: "17px", margin: "8px 0 3px" }}>{t.name}</div>
            <div style={{ color: "#8b949e", fontSize: "12px", lineHeight: 1.4 }}>{t.desc}</div>
            <span style={{ display: "inline-block", fontSize: "10px", padding: "2px 8px", borderRadius: "20px", background: "#21262d", color: "#8b949e", marginTop: "10px" }}>{t.tag}</span>
          </a>
        ))}
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d" }}>
        <b style={{ color: "#e6edf3", fontSize: "14px" }}>🧰 Logiciels installés (sur le PC, pas accessibles depuis le Hub)</b>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "6px 16px", marginTop: "10px" }}>
          {APPS.map(([cat, list]) => (
            <div key={cat} style={{ fontSize: "12px", color: "#8b949e", lineHeight: 1.5 }}>
              <b style={{ color: "#c9d1d9" }}>{cat}</b><br />{list}
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d", color: "#8b949e", fontSize: "13px", lineHeight: 1.6 }}>
        <b style={{ color: "#e6edf3" }}>ℹ️ Aide-mémoire</b><br />
        • <b>Écran à distance</b> : RustDesk → adresse <b>100.68.208.75</b> (ou MeshCentral, appareil TUF). SSH : utilisateur <b>kermh</b>.<br />
        • <b>Matériel</b> : i7-13650HX · 32 Go RAM · <b>RTX 4060 Laptop 8 Go</b> · SSD 1 To + disque USB 1 To.<br />
        • <b>Nomade</b> : injoignable quand il est en veille ou sans réseau (le Wi-Fi coupé = pas de réseau sans câble).<br />
        • Inventaire relevé le <b>28/09 soir</b>. Disque C: <b>232 Go libres</b>. Mots de passe → <b>Vaultwarden</b>.
      </div>
    </div>
    </div>
  )
}
